import { createComparisonStore } from "@/components/comparison/create-comparison-store";
export interface ComparisonSelection { id: string; name: string; avatarContent?: string | null; avatarMime?: string | null }
export const useProfileComparisonStore = createComparisonStore<ComparisonSelection>();
